<div class="item" *ngFor="let item of headerStatistics; let i = index, trackBy: trackByIndex" [ngClass]="getStatisticsClass(item)">
  <p class="header">{{item.key}}</p>
  <a [routerLink]="[]" *ngIf="item.url != ''" class="headerStatsItem" (click)="navigateToUrl(item.url, item.key)"><span  class="bold">{{item.value}}</span></a>
  <span *ngIf="item.url == ''" class="font-size-2 bold">{{item.value}}</span>
</div>
